import { cn } from "@/lib/utils";
import { DEFAULT_STYLE, STYLES_BY_KIND, drivetrainById, styleRoles, styleText } from "@/rc/drivetrains";
import { ChoiceCard } from "./ChoiceCard";
import { ControllerDiagram } from "./ControllerDiagram";

const StickRole = ({ side, role }) => (
  <div className={cn("rounded-lg border px-2.5 py-1.5", role ? "border-primary/40 bg-secondary text-secondary-foreground" : "border-dashed text-muted-foreground")}>
    <p className="font-semibold">{side}</p>
    <p>{role ? role.label : "Not used"}</p>
  </div>
);

export const ControlsStep = ({ cfg, onPick }) => {
  const dt = drivetrainById(cfg.drivetrain);
  return (
    <div data-testid="rc-controls-step">
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3" role="radiogroup" aria-label="Controller layout">
      {STYLES_BY_KIND[dt.kind].map((id) => {
        const t = styleText(id, dt.kind);
        const roles = styleRoles(id, dt.kind);
        return (
          <ChoiceCard key={id} selected={cfg.style === id} onClick={() => onPick(id)} testId={`rc-style-${id}`}>
            {DEFAULT_STYLE[dt.kind] === id && (
              <span className="absolute left-3 top-3 z-10 rounded-full bg-[hsl(var(--rc-hot)/0.14)] px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider text-[hsl(var(--rc-hot))]">Popular</span>
            )}
            <div className="rounded-xl bg-muted/40 px-6 pb-3 pt-8">
              <ControllerDiagram roles={roles} className="mx-auto w-full max-w-[210px]" />
            </div>
            <div className="mt-3 grid grid-cols-2 gap-2 text-xs">
              <StickRole side="Left stick" role={roles.left} />
              <StickRole side="Right stick" role={roles.right} />
            </div>
            <p className="mt-3 font-display text-base font-bold">{t.name}</p>
            <p className="mt-1 text-sm text-muted-foreground">{t.desc}</p>
          </ChoiceCard>
        );
      })}
    </div>
    </div>
  );
};
